/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
     
      // ... update some element on the page
    }
  });



// Custom JS to hide size selector on selecting unstitched

    document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    var sizeselector = document.querySelector('[data-select-label="Size"]');
    var customForm = document.getElementById('custom_size_form');
    var customFormInputs = customForm.querySelectorAll('input');

    // Check of variant title includes a size

    if (variant.title.includes('/ XS') || variant.title.includes('/ S') || variant.title.includes('/ M') || variant.title.includes('/ L') || variant.title.includes('/ XL') || variant.title.includes('XXL')  ) {
      var size_in_title = true;
    } else {
      var size_in_title = false;
    }

    // Hide sizes when selected variant is UNSTITCHED & Unstitched is not a part of Sizes
    
    if (variant) {
      if (variant.title.includes('UNSTITCHED') && size_in_title !== false ) {
        sizeselector.style.opacity = "0";
        sizeselector.style.height = "0";
        console.log("Hiding sizes Selceto", variant);
       } else {
         sizeselector.style.opacity = "1";
         sizeselector.style.height = "auto";
       }   

      //  Custom Size form
      //if (sizeselector.dataset.hide.includes('CUSTOM') || sizeselector.dataset.hide.includes('Custom')) {
        if (variant.title.includes('CUSTOM') || variant.title.includes('Custom')) {
          customForm.removeAttribute('hidden');
          console.log("Showing custom form", event);
        }
        else {
          customForm.setAttribute('hidden', true);
          console.log("Hiding Form", event);
          customFormInputs.forEach(element => {
            element.value = "";     
          });
          customFormLabels.forEach(element => {
            element.classList.remove('label--float');
          });
        }
     // }


      // ... update some element on the page
    }
  });
    // document.addEventListener('theme:cart:change', function(event) {
    //   var cart = event.detail.cart;
    //   if (cart) {
    //     console.log('Cart ———————————— ↓');
    //     console.log(cart);
    //     // ... update an app or a custom shipping caluclator
    //   }
    // });
  // Fired when page loads to update header values
    // document.addEventListener('theme:cart:init', (e) => {
    //   console.log('theme:cart:init');
    //   console.log(e);
    // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
    // document.addEventListener('theme:scroll', e => { console.log(e); });
    // document.addEventListener('theme:scroll:up', e => { console.log(e); });
    // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
    // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
